import React from 'react';
import { ClassValue } from 'classnames/types';
import styles from './ButtonText.module.scss';
import Typography, { TypographyProps } from '../Typography';
import { ArrayElementType } from '../../../types/utils/ArrayElementType';
import { CreateProps } from '../../../types/utils/CreateProps';

type ButtonTextProps = CreateProps<
  {
    size?: SupportedButtonTextSize;
  },
  TypographyProps<'span'>,
  'tagName' | 'font' | 'uppercase' | 'fontWeight'
>;

const ButtonText: React.FunctionComponent<ButtonTextProps> = ({
  size = 'md',
  className,
  children,
  ...props
}) => {
  const classNames: ClassValue = [
    styles[`buttonText__size_${size.toLowerCase()}`],
    className,
  ];

  return (
    <Typography
      {...props}
      className={classNames}
      font="teliasans"
      uppercase
      fontWeight="bold"
    >
      {children}
    </Typography>
  );
};

export const supportedButtonTextSizes = ['md', 'sm'] as const;

export type SupportedButtonTextSize = ArrayElementType<
  typeof supportedButtonTextSizes
>;

export default ButtonText;
